module.exports = __webpack_public_path__ + "static/media/suggestion-tabletportrait.74d241fb.png";